
import { throwError as observableThrowError, Observable } from 'rxjs';
import { Component, Inject, OnInit, Input, EventEmitter, OnDestroy, ViewChild, OnChanges, SimpleChanges, SimpleChange, Output } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import { DialogdeleteComponent } from 'basecomponents';
//app
import { UserNewComponent } from '../user-edit/user-new.component';
import { User } from 'solar-bo';
import { UserService } from '../user.service';

import { ErrorcontrolService } from 'basecomponents';
import { ListBaseComponent } from '@solar/shared/list-base.component';
import { AppConfig } from '@solar/app.config';
import { GlobalService } from '@solar/services/global.service';
import { ISdsAction } from '@solar/services';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss']
})
export class UserListComponent extends ListBaseComponent implements OnInit, OnChanges {

  @Input() routeActive = true;
  users: User[]=[];

  displayedColumns = ['name','surname','position','phone', 'username','modifydate', 'actions'];
  dataSource = new MatTableDataSource<User>();
  @Output() userSelectedEvent:EventEmitter<User>=new EventEmitter();
  @Output() userDeletedEvent:EventEmitter<User>=new EventEmitter();

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;


  constructor(private adminService: UserService
    , private globalService: GlobalService
    , public dialog: MatDialog
    ) {
      super();
      this.dataSource = new MatTableDataSource<User>(this.users);
      this.globService.actions.subscribe((action) => this.sdsServiceActionsHandler(action));
  }

  sdsServiceActionsHandler(action: ISdsAction) {
    if (action) {
      if (action.action == "USER_CHANGED") {
        this.getList();
      }
    }
  }

  ngOnChangeshappen: boolean = false;

  ngOnInit() {
    console.log("ngOnInit dialog", this.dialog);
    console.log("ngOnInit ngOnChangeshappen", this.ngOnChangeshappen);
    if (this.ngOnChangeshappen == false) {

      this.getList();
    }
    this.statusok = true;
  }

  ngOnChanges(changes: SimpleChanges) {
  }

  getList(): void {
    this.listerrmessage = "";
    this.loadinglist = true;
    this.adminService.getUsers()
      .subscribe(
        users => this.handleresult(users)
        , err => this.getUsersListHandleError(err)
      );
  }

  handleresult(users: User[]) {
    this.listerrmessage = "";
    this.loadinglist = false;
    this.users = users;
    this.dataSource = new MatTableDataSource<User>(this.users);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  getUsersListHandleError<T>(err: any) {
    this.loadinglist = false;
    this.handleError(err, "Error retrieving supervisions list");
  }
  handleError(err, genericMessage?: string) {
    this.loadinglist = false;
    this.alertmessage = ErrorcontrolService.basichandleError(genericMessage, err);
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  delete(user: User): void {
    this.users = this.users.filter(h => h !== user);
    this.adminService.deleteUser(user).subscribe();
  }

  openDialogDeleteUser(userToDelete: User): void {
    let title="Delete User";
    let message= "Do you want to delete user: " + userToDelete.name + " " + userToDelete.surname;

    let dialogRef = this.openDialogDelete(title, message, userToDelete);
    dialogRef.componentInstance.mainActionEmitter.subscribe(() => this.deleteElement(dialogRef,userToDelete));
   }

  deleteElement(dialogRef: MatDialogRef<DialogdeleteComponent>,userToDelete: User) {
    
     this.adminService.deleteUser(dialogRef.componentInstance.modelinfo)
      .subscribe(() => { 
        this.alertService.info("User deleted")
        , dialogRef.close()
        , this.userDeletedEvent.emit(userToDelete)
        ,this.getList() }
        , err => this.alertService.error("Error deleting user: " + err.message)
      ); 
  }


  newElement(user?: User) {
    if (!user){
      user=new User();
      user.profile.access_level.push(2);
    }

    let dialogRef: MatDialogRef<UserNewComponent>;
    dialogRef = UserNewComponent.openModal(this.dialog, user);
    dialogRef.componentInstance.saveEvent.subscribe((model) => this.saveUserEvent(dialogRef, null, model));

    //this.router.navigateByUrl(AppConfig.ROUTE_SOLAR + "/supervision");
    //this.router.navigate(['site/' , item.id],{relativeTo:this.route});
  }

  saveUserEvent(dialogRef: MatDialogRef<any>,itemToEdit:User,site:User) {
    dialogRef.close();
    this.getList();
  }
  openitem(item:User){

    //this.router.navigateByUrl(AppConfig.ROUTE_SOLAR + "/supervision-master/" + item.id);
    //this.router.navigate(['site/' , item.id],{relativeTo:this.route});
  /*   let itemPath={path:"/supervision-master/" + item.id};
    this.globService.menuSelectedEvent_raise(itemPath); */
    if (this.routeActive) {
     this.router.navigateByUrl("/users/user-detail/" + item.id);
    
    } else {
      this.userSelectedEvent.emit(item);
    }
  }

  uigetphone(row){
    if (row.info.phone){
      return row.info.phone[0];
    }
    else{
      return "";
    }
  }

}
